module.exports = __webpack_public_path__ + "img/img-main-bg04.92c801e8.png";